module.exports = __webpack_public_path__ + "img/logo.213e47e7.jpg";